import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery, post } from "../queryHelpers";

export interface InitiateCallRequest {
  channelId: number;
  toNumber: string | null;
  toCustomer: string | null;
  workItemId: string | null;
  agentWorkspaceId: string | null;
  isMobileSession: boolean;
  musicOnHoldBundleName: string | null;
  customerLanguageProfileId: string | null;
  agentLanguageProfileId: string | null;
  copilotId: string | null;
}

const sipConnectorApi = createApi({
  reducerPath: "sipConnectorApi",
  tagTypes: [],
  baseQuery: apiBaseQuery("/sipconnector"),
  endpoints: builder => ({
    initiateCall: builder.mutation<void, InitiateCallRequest>({
      query: request => post("/api/v1/Call/initiate", request),
    }),
  }),
});

export const { useInitiateCallMutation } = sipConnectorApi;

export default sipConnectorApi;
